<div *ngIf="!isFromBRPortal">
  <a
    #navItem
    mat-list-item
    role="listitem"
    tabindex="0"
    *ngFor="let item of items; let idx = index"
    class="nav-item"
    (click)="makeActiveBrokerTemp(item.text); navigatePage(item)"
    [ngClass]="{
      'router-link-active': checkActiveRoute(item),
      disabledMenu:
        isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    }"
    [attr.data-test-id]="'sn' + item.icon"
    (mouseenter)="menuEnter(menuTrigger, item)"
    (mouseleave)="menuLeave($event, item, navItem)"
    (focus)="menuEnter(menuTrigger, item)"
    [disabled]="
      isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    "
  >
    <div
      class="active-strip"
      [attr.data-test-id]="'snActiveRoutePage-' + idx"
    ></div>
    <div
      class="icon-wrap {{ item.icon }}"
      [attr.data-test-id]="'snMenuIconClass-' + idx"
    ></div>
    <div
      class="menuLabelText"
      [attr.data-test-id]="'lblSnMenuLabelText-' + idx"
    >
      {{ item.text }}
    </div>
    <div *ngIf="item.submenu?.length" class="icon-wrap arrow-forward"></div>
    <div
      class="menuTrigger"
      [matMenuTriggerFor]="subMenu"
      #menuTrigger="matMenuTrigger"
      tabindex="-1"
    >
      <mat-menu
        #subMenu="matMenu"
        class="subMenu"
        xPosition="after"
        yPosition="below"
        [hasBackdrop]="false"
      >
        <div
          (mouseleave)="menuTrigger.closeMenu()"
          (keydown)="menuLeave($event)"
        >
          <button
            mat-menu-item
            *ngFor="let subItem of item.submenu"
            [attr.data-test-id]="'btnSubMenu' + subItem.text?.replace(' ', '')"
            (click)="navigatePage(subItem)"
            [attr.tabIndex]="item.submenu?.length ? '0' : '-1'"
          >
            {{ subItem?.text }}
            <div *ngIf="subItem?.icon">
              <cigna-icon [type]="subItem.icon"></cigna-icon>
            </div>
          </button>
        </div>
      </mat-menu>
    </div>
  </a>

  <mat-divider *ngIf="items?.length > 0"></mat-divider>

  <a
    #navItem2
    mat-list-item
    role="listitem"
    tabindex="0"
    *ngFor="let item of profileItems; let idx = index"
    class="nav-item"
    (click)="makeActiveBrokerTemp(item.text); navigatePage(item)"
    [ngClass]="{
      'router-link-active': checkActiveRoute(item),
      disabledMenu:
        isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    }"
    [attr.data-test-id]="'sn' + item.icon"
    (mouseenter)="menuEnter(menuTrigger, item)"
    (mouseleave)="menuLeave($event, item, navItem2)"
    (focus)="menuEnter(menuTrigger, item)"
    [disabled]="
      isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    "
  >
    <div
      class="active-strip"
      [attr.data-test-id]="'snActiveRoutePage-' + idx"
    ></div>
    <div
      class="icon-wrap {{ item.icon }}"
      [attr.data-test-id]="'snMenuIconClass-' + idx"
    ></div>
    <div
      class="menuLabelText"
      [attr.data-test-id]="'lblSnProfileMenuLabelText-' + idx"
    >
      {{ item.text }}
    </div>
    <div *ngIf="item.submenu?.length" class="icon-wrap arrow-forward"></div>
    <div
      class="menuTrigger"
      [matMenuTriggerFor]="profileSubMenu"
      #menuTrigger="matMenuTrigger"
      tabindex="-1"
    >
      <mat-menu
        #profileSubMenu="matMenu"
        class="subMenu"
        xPosition="after"
        yPosition="below"
        [hasBackdrop]="false"
      >
        <div
          (mouseleave)="menuTrigger.closeMenu()"
          (keydown)="menuLeave($event)"
        >
          <button
            mat-menu-item
            *ngFor="let subItem of item.submenu"
            [attr.data-test-id]="'btnSubMenu' + subItem.text.replace(' ', '')"
            (click)="navigatePage(subItem)"
            [attr.tabIndex]="item.submenu?.length ? '0' : '-1'"
          >
            {{ subItem?.text }}
            <div *ngIf="subItem?.icon">
              <cigna-icon [type]="subItem.icon"></cigna-icon>
            </div>
          </button>
        </div>
      </mat-menu>
    </div>
  </a>

  <mat-divider *ngIf="profileItems?.length > 0"></mat-divider>

  <a
    mat-list-item
    role="listitem"
    tabindex="0"
    *ngFor="let item of communicationItems; let idx = index"
    class="nav-item"
    (click)="makeActiveBrokerTemp(item.text); navigatePage(item)"
    [ngClass]="{
      'router-link-active': checkActiveRoute(item),
      disabledMenu:
        isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    }"
    [attr.data-test-id]="'sn' + item.icon"
    (mouseenter)="menuEnter(menuTrigger, item)"
    (focus)="menuEnter(menuTrigger, item)"
    [disabled]="
      isInternalUser && selectedClient === '' && item.text !== 'Dashboard'
    "
  >
    <div
      class="active-strip"
      [attr.data-test-id]="'snActiveRoutePage-' + idx"
    ></div>
    <div
      class="icon-wrap {{ item.icon }}"
      [attr.data-test-id]="'snMenuIconClass-' + idx"
    ></div>
    <div
      class="menuLabelText"
      [attr.data-test-id]="'lblSnCommunicationsMenuLabelText-' + idx"
    >
      {{ item.text }}
    </div>
  </a>

  <mat-divider *ngIf="communicationItems?.length > 0"></mat-divider>

  <a
    mat-list-item
    role="listitem"
    tabindex="0"
    class="nav-item"
    *ngIf="isLinkEnabled"
    (click)="makeActiveBrokerTemp(goToLink.text); navigatePage(goToLink)"
    [ngClass]="{
      disabledMenu:
        isInternalUser &&
        selectedClient === '' &&
        goToLink?.text !== 'Dashboard'
    }"
    [attr.data-test-id]="'sn' + goToLink?.icon"
    (mouseenter)="menuEnter(menuTrigger, goToLink)"
    (focus)="menuEnter(menuTrigger, goToLink)"
    [disabled]="
      isInternalUser && selectedClient === '' && goToLink?.text !== 'Dashboard'
    "
  >
    <div class="nav-item" data-test-id="snActiveRoutePage-GotoLink"></div>
    <div
      class="icon-wrap {{ goToLink?.icon }}"
      data-test-id="snMenuIconClass-GotoLink"
    ></div>
    <div class="menuLabelText" data-test-id="lblSnMenuLabelText-GotoLink">
      {{ goToLink?.text }}
    </div>
  </a>
</div>
<div class="brkSideNav">
  <div
    *ngFor="let item of items; let idx = index"
    (click)="
      item.submenu && item.submenu.length ? $event.stopPropagation() : ''
    "
  >
    <div *ngIf="item.submenu && item.submenu.length > 0">
      <mat-accordion>
        <mat-expansion-panel
          (afterExpand)="onMatExpanded(item.text, idx)"
          [expanded]="item.open || item.text == activeNavMenu"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <a
                #navItem
                mat-list-item
                role="listitem"
                tabindex="0"
                class="nav-item"
                (click)="makeActiveBrokerTemp(item.text)"
                [ngClass]="{
                  'router-link-active': checkActiveRoute(item)
                }"
              >
                <div
                  class="active-strip"
                  [attr.data-test-id]="'snActiveRoutePage-' + idx"
                ></div>
                <div
                  class="icon-wrap {{ item.icon }}"
                  [attr.data-test-id]="'snMenuIconClass-' + idx"
                ></div>
                <div
                  class="small-group-margin menuLabelText"
                  data-test-id="left-nav-menu"
                  *ngIf="item.text === 'U.S. Employer & Small Group Plans'"
                >
                  <div fxLayout="row">U.S. Employer &&nbsp;</div>
                  <div fxLayout="row">Small Group Plans</div>
                </div>
                <div
                  *ngIf="item.text !== 'U.S. Employer & Small Group Plans'"
                  class="menuLabelText"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  data-test-id="left-nav-menu"
                >
                  {{ item.text }}
                </div>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div
            *ngFor="let child of item.submenu"
            [ngClass]="{
              'nav-sub-menu-item router-link-active':
                checkActiveSubMenuRoute(child)
            }"
          >
            <cigna-brk-nav-item-sub-menu
              *ngIf="child.text === 'Tools' && child.submenu.length"
              [item]="child"
              [parentItem]="item"
              [idx]="idx"
              [isImpersonatorFlag]="isImpersonatorFlag"
              [hasIfpAdminMenu]="hasIfpAdminMenu"
              (itemClicked)="onNavItemSubMenuItemClicked($event)"
            >
            </cigna-brk-nav-item-sub-menu>
            <cigna-brk-nav-item-sub-menu
              *ngIf="child.text !== 'Tools'"
              [item]="child"
              [parentItem]="item"
              [idx]="idx"
              [isImpersonatorFlag]="isImpersonatorFlag"
              [hasIfpAdminMenu]="hasIfpAdminMenu"
              (itemClicked)="onNavItemSubMenuItemClicked($event)"
            >
            </cigna-brk-nav-item-sub-menu>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="!item.submenu || item.submenu.length === 0">
      <a
        #navItem
        mat-list-item
        role="listitem"
        tabindex="0"
        class="nav-item"
        (click)="subMenuItemClicked(item)"
        [ngClass]="{
          'router-link-active': checkActiveRoute(item)
        }"
      >
        <div
          class="active-strip"
          [attr.data-test-id]="'snActiveRoutePage-' + idx"
        ></div>
        <div
          class="icon-wrap {{ item.icon }}"
          [attr.data-test-id]="'snMenuIconClass-' + idx"
        ></div>
        <div
          class="menuLabelText"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          data-test-id="left-nav-menu"
        >
          {{ item.text }}
        </div>
      </a>
    </div>
  </div>

  <div class="my-messages">
    <button
      mat-raised-button
      role="listitem"
      tabindex="0"
      data-test-id="my-messages"
      cg-mat-btn-type="secondary"
      class="btn-msgs"
      [routerLink]="'/secure/broker-messages'"
      (click)="getMyMessages()"
    >
      <cigna-icon class="bell-icon" type="bell"></cigna-icon>
      <div class="notification-dot"></div>
      <span class="msg-text" data-test-id="left-nav-my-messages">
        {{ 'broker.mymessages' | translate | uppercase }}
      </span>
    </button>
  </div>
</div>
